module.exports = __webpack_public_path__ + "img/logo-government-7.71c13059.png";